var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_2632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 19C14.7467 19 19 14.7467 19 9.5C19 4.25329 14.7467 0 9.5 0C4.25329 0 0 4.25329 0 9.5C0 14.7467 4.25329 19 9.5 19Z",
    fill: "#32BA7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.07256 13.7855L11.9574 18.6703C16.0032 17.5914 19 13.9053 19 9.49996C19 9.41006 19 9.32015 19 9.23025L15.164 5.69397L7.07256 13.7855Z",
    fill: "#0AA06E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73975 11.6278C10.1593 12.0474 10.1593 12.7666 9.73975 13.1862L8.87066 14.0552C8.4511 14.4748 7.73186 14.4748 7.3123 14.0552L3.50631 10.2193C3.08675 9.79973 3.08675 9.08049 3.50631 8.66093L4.37539 7.79184C4.79495 7.37228 5.5142 7.37228 5.93375 7.79184L9.73975 11.6278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0662 5.00473C13.4858 4.58517 14.205 4.58517 14.6246 5.00473L15.4937 5.87382C15.9132 6.29338 15.9132 7.01262 15.4937 7.43218L8.90063 13.9953C8.48107 14.4148 7.76183 14.4148 7.34227 13.9953L6.47319 13.1262C6.05363 12.7066 6.05363 11.9874 6.47319 11.5678L13.0662 5.00473Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_2632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.6d83c95cce6be56af37df7f3ed11bde5.svg";
export { ForwardRef as ReactComponent };